import { render, staticRenderFns } from "./DmsEditLayout.vue?vue&type=template&id=34792141&scoped=true&"
import script from "./DmsEditLayout.vue?vue&type=script&lang=js&"
export * from "./DmsEditLayout.vue?vue&type=script&lang=js&"
import style0 from "./DmsEditLayout.vue?vue&type=style&index=0&id=34792141&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34792141",
  null
  
)

export default component.exports